export const tableVirtualizedStyles = theme => ({
    rowRootCommon: {
        fontFamily: theme.fontFamily,
        fontSize: 13
    },
    cellRootCommon: {
        overflow: 'hidden',
        '&:last-child $cellInnerCommon': {
            paddingRight: '24px'
        }
    },
    firstCellRootCommon: {
        '& $cellInnerCommon': {
            paddingLeft: '24px'
        }
    },
    cellInnerCommon: {
        padding: '0 8px'
    },
    hierarchyHeaderCellRoot: {
        '&:first-child $cellInnerCommon': {
            paddingLeft: HIERARCHY_DROPDOWN_OUTER_WIDTH
        }
    },
    firstColumnOfHierarchyRoot: {
        '& $cellInnerCommon': {
            paddingLeft: 0
        }
    },
    cellAlignCenter: {
        justifyContent: 'center'
    }
})

export const getOddRowBackground = theme => theme.tertiary
export const getEvenRowBackground = theme => theme.background

export const HIERARCHY_DROPDOWN_OUTER_WIDTH = 50
export const HIERARCHY_DROPDOWN_BTN_WIDTH = HIERARCHY_DROPDOWN_OUTER_WIDTH - 5
